export const sessionCard = () => {
  return {
    padding: "50px 100px",
    backgroundColor: "white",
  };
};
